require('./openYoungProfilesView.scss');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');

// @components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @actions
const openYoungProfilesActions = require('actions/openYoungProfiles');

class OpenYoungProfilesView extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetryButton = this.handleRetryButton.bind(this);
    }

    componentDidMount() {
        const {getOpenYoungProfiles, immOpenYoungProfiles} = this.props;

        if (!immOpenYoungProfiles.get('fetchSuccess')) {
            getOpenYoungProfiles();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immOpenYoungProfiles } = nextProps;

        if (immOpenYoungProfiles.get('fetchSuccess') && immOpenYoungProfiles.get('byId').size === 0) {
            this.props.history.push(`/myprofile/edit`);
        }
    }

    handleRetryButton() {
        this.props.getOpenYoungProfiles();
    }

    buildBeneficiary(immBeneficiary, index) {
        return (
            <OKSectionBox key={index} className="open-young-profiles-view__section" title={formatText('openyoungProfiles-openyoungProfiles_beneficiary')}>
                <div className="row">
                    <div className="col-xs-12 content-no-padding">
                        <OKInformativeList columns={1}>
                            <OKInformativeListItem
                                className="open-young-profiles-view__section-beneficiary"
                                title={formatText('openyoungProfiles-openyoungProfiles_fullName')}
                            >
                                <span className="open-young-profiles-view__beneficiary-name">
                                    {immBeneficiary.get('name')}
                                </span>
                            </OKInformativeListItem>
                        </OKInformativeList>
                    </div>
                    <div className="col-xs-12 open-young-profiles-view__last-cell">
                        <OKLink
                            modifier="complementary"
                            to={`/myprofile/openyoung-profile-details/${immBeneficiary.get('id')}`}
                        >
                            <FormattedText value="openyoungProfiles-openyoungProfiles_edit" />
                        </OKLink>
                    </div>
                </div>
            </OKSectionBox>
        );
    }

    buildContent() {
        const { immOpenYoungProfiles } = this.props;
        return immOpenYoungProfiles.get('byOrder').map((profileId, index) => {
            const immBeneficiary = immOpenYoungProfiles.getIn(['byId', profileId]);

            if (immBeneficiary.get('isUnder18')) {
                return this.buildBeneficiary(immBeneficiary, index);
            }
        });
    }

    render () {
        const { immOpenYoungProfiles, immGlobalVariables } = this.props;
        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );
        const boxTitle = formatText('profile-boxTitle');
        const breadcrumbConfig = [{
            text: formatText('breadcrumb-personalInformation'),
            url: '/myprofile/edit'
        }, {
            text: formatText('breadcrumb-breadcrumb_openYoungInformation'),
            url: ''
        }];
        let content;

        if (immOpenYoungProfiles.get('isFetching')) {
            content = (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        } else if (immOpenYoungProfiles.get('fetchSuccess')) {
            content = this.buildContent();
        } else if (immOpenYoungProfiles.get('error')) {
            const retryButton = (
                <OKButton onClick={this.handleRetryButton}>
                    <FormattedText value="common-retry" />
                </OKButton>
            );

            content = (
                <OKSectionBox>
                    <EmptyState
                        button={retryButton}
                        iconType="nointernet-banking"
                        primaryText={formatText('openyoungProfiles-openyoungProfiles_errorModalText', [immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente'])])}
                    />
                </OKSectionBox>
            );
        }

        return (
            <div className="open-young-profiles-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumbConfig}
                                finalTitle={getFinalTitle('profile-profile_openYoungTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-8">
                                {content}
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-12 grid-view--variable-cell-separation">
                                        <ContactInfoBox
                                            boxBody={boxBody}
                                            boxTitle={boxTitle}
                                            hasMessage={true}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack pageTitle={formatText('breadcrumb-personalInformation')} hasEntrance={false} />
                                    </div>
                                    <div className="col-xs-12 grid-view--fix-cell-separation">
                                        <CommercialAds path={'edit'} type="banner-a" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungProfilesView.propTypes = {
    getOpenYoungProfiles: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immOpenYoungProfiles: PropTypes.object.isRequired,
}

module.exports.constructor = OpenYoungProfilesView;

module.exports.OpenYoungProfilesView = connect(
    state => ({
        immGlobalVariables: state.globalVariables,
        immOpenYoungProfiles: state.openYoungProfiles,
    }), {
        getOpenYoungProfiles: openYoungProfilesActions.getOpenYoungProfiles,
    }
)(withRouter(OpenYoungProfilesView));
